import React, { useState } from "react";
import { TextField, Button, Typography } from "@material-ui/core";
import flightGenerator from "random-flight-generator";
import CustomCard from "../../components/CustomCard";
import Tutorial from "../../components/Tutorial";
import Footer from "../../components/Footer";
import styles from "./style";
import { IFlight } from "../../utils/models";

const Home = () => {
  const NUMBER_OF_FLIGHTS = 10;
  const [departure, setDeparture] = useState("");
  const [arrival, setArrival] = useState("");
  const [minDistance, setMinDistance] = useState<any>("");
  const [maxDistance, setMaxDistance] = useState<any>("");
  const [flights, setFlights] = useState<IFlight[]>([]);
  //const [ searchError, setVisibleError ] = useState(false);

  const onSubmit = (e: any) => {
    e.preventDefault();
    setFlights([]);

    const options = {
      minDistance: minDistance ? minDistance : 5,
      maxDistance: maxDistance ? maxDistance : 300,
      majorAirportsOnly: true,
      departure: departure,
      arrival: arrival,
    };
    //console.debug("Research options: " + JSON.stringify(options))

    for (let i = 0; i < NUMBER_OF_FLIGHTS; i++) {
      try {
        let generatedFlight: IFlight = flightGenerator(options).toJson();
        setFlights((flights: IFlight[]) => [...flights, generatedFlight]);
        //console.debug("Generated flight: " + JSON.stringify(generatedFlight))
      } catch (e) {
        console.log(e, "errore");
      }
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          padding: 20,
          boxShadow: "10px 3px 10px grey",
          textAlign: "center",
        }}
      >
        <h1>Random Flight Generator</h1>
        <form noValidate autoComplete="off" onSubmit={(e) => onSubmit(e)}>
          <TextField
            id="departure"
            label="Departure (ICAO)"
            onChange={({ target: { value } }) => setDeparture(value)}
            style={styles.formInput}
          />
          <TextField
            id="arrival"
            label="Arrival (ICAO)"
            onChange={({ target: { value } }) => setArrival(value)}
            style={styles.formInput}
          />
          <TextField
            id="minDistance"
            label="Min distance (in NM)"
            onChange={({ target: { value } }) => setMinDistance(value)}
            style={styles.formInput}
          />
          <TextField
            id="maxDistance"
            label="Max distance (in NM)"
            onChange={({ target: { value } }) => setMaxDistance(value)}
            style={styles.formInput}
          />
          <Button
            variant="contained"
            color="primary"
            style={{ display: "block", marginTop: 16, width: "100%" }}
            type="submit"
          >
            Search
          </Button>
        </form>
      </div>
      {flights.length > 0 && (
        <div style={{ color: "grey", marginTop: 16 }}>
          <Typography variant="h6" align="center">
            Click on a flight to see the route on SkyVector
          </Typography>
        </div>
      )}
      <div
        style={{
          margin: 20,
          display: "flex",
          flexFlow: "wrap",
          justifyContent: "space-around",
        }}
      >
        {flights &&
          flights.length > 0 &&
          flights.map((flight: IFlight, key: number) => (
            <CustomCard key={key} flight={flight} />
          ))}
        {flights.length === 0 && <Tutorial />}
      </div>
      <Footer />
    </div>
  );
};

export default Home;
